<template>

    <div v-if="showMe">
        
        <v-row id="widj-box" class="p-0">
            <v-col class="pt-0">

                <v-row id="top-box">
                    <v-col class="text-center">
                        Week {{ latest_completed_week.play_week_num }}
                    </v-col>
                </v-row>
                
                <v-row>
                    <v-col>
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th class="px-0">Pos</th>
                                    <th class="px-0">Player</th>
                                    <th class="px-0">Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="index in 5" :key="index">
                                    <td class="px-0">{{ weeklyScores[index].rank }}</td>
                                    <td class="px-0">{{ weeklyScores[index].username }}</td>
                                    <td class="px-0">{{ weeklyScores[index].tot_pts_won }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>        
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-0">
                        <v-btn class="float-right" x-small outlined color="secondary" @click="$router.push('weekly-scores')">View Full Table</v-btn>
                    </v-col>
                </v-row>
                
            </v-col>
        </v-row>

    </div>

</template>

<script>

import {mapGetters} from "vuex";

export default {
    name: "WeeklyScoresWidget",
    props: [
      //
    ],
    components: {
      //
    },
    data: () => ({
        showMe: false,
    }),
    computed: {
        ...mapGetters([
            'latest_completed_week',
            'weeklyScores',
        ]),
    },
    methods: {

    },
    created() {

        if (this.weeklyScores) {
            this.showMe = true;
        }
        
        this.unwatchlatestweek = this.$store.watch(
            (state, getters) => getters.latest_completed_week,
            (newValue, oldValue) => {
                if (!this.weeklyScores) {
                    this.$store.dispatch('getWeeklyScores', { weekId: newValue.id })
                } 
            }
        )
        this.unwatchweeklyscores = this.$store.watch(
            (state, getters) => getters.weeklyScores,
            (newValue, oldValue) => {
                this.showMe = true;
            }
        )

    },
    beforeDestroy() {
        this.unwatchlatestweek();
        this.unwatchweeklyscores();
    }

}
</script>

<style scoped>

    #widj-box {
        border: 2px solid var(--v-secondary-base);
        background-color: #EFEBE9;
    }

    #top-box {
        background-color: var(--v-secondary-base);
        color: #fff;
    }

    .link-btn {
        color: black !important;
    }

    .v-data-table>.v-data-table__wrapper>table>tbody>tr>td{
        background-color: #EFEBE9;
        font-size: 0.8rem;
    }
    .v-data-table>.v-data-table__wrapper>table>thead>tr>th{
        background-color: #EFEBE9;
        font-size: 0.8rem;
    }

</style>
